import React, { PropTypes, Component } from 'react';
import { Units, Colors } from 'Css';
import classNames from 'classnames';
import { FlatButton, IconButton } from 'material-ui';
import { Styles } from 'material-ui';
import * as SvgIcons from 'components/Material/SvgIcons';
let { ActionExitToApp } = SvgIcons;
const { Spacing } = Styles;
const css = oxygenCss({
  footer: {
    left: '50px'
  }
});

export default class ProfileLogout extends Component {
  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  static propTypes = {
    logOut: PropTypes.func
  };

  state = {
    mouseOver: false
  };

  getStyle() {
    const { style } = this.props;
    const { mouseOver } = this.state;
    return Object.assign(
      {},
      {
        position: 'relative',
        cursor: 'pointer',
        backgroundColor: mouseOver ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
        paddingLeft: '135px',
        paddingRight: '25px',
        height: 48,
        lineHeight: '48px',
        fontSize: '16px',
        color: 'white',
        bottom: '0px',
        left: '-10px'
      },
      style
    );
  }

  logOut() {
    if (this.props.logout) {
      this.props.logout();
    }
  }

  handleMouseEnter() {
    this.setState({ mouseOver: true });
  }

  handleMouseLeave() {
    this.setState({ mouseOver: false });
  }

  render() {
    let text = this.context.getIntlMessage('menu.Logout');

    return (
      <div
        className={css.footer}
        style={this.getStyle()}
        onMouseEnter={this.handleMouseEnter.bind(this)}
        onMouseLeave={this.handleMouseLeave.bind(this)}
        onTouchTap={this.logOut.bind(this)}
      >
        <IconButton style={{ marginLeft: '-90px', float: 'left' }}>
          <ActionExitToApp color={'white'} />
        </IconButton>
        <span style={{ float: 'left', marginLeft: '-45px' }}> {text} </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Widgets/ProfileLogout.js